import React, { useState, useEffect } from "react";

import AdminPage from "../AdminPage";
import axios from "axios";
import { SERVERURL } from "../../../ServerUrl";
import Swal from "sweetalert2";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';



const COPY = {
  title: "Add Announcement",
  subtitle:
    "Shown in the scrolling banner on the homepage. Links become clickable and *text* turns bold.",
  announcement: "Announcement",
  upload: "Upload",
};

const AddBanner = () => {
  const [banner, setBanner] = useState("");
  const handleBannerChange = (content) => {
    setBanner(content); // ReactQuill passes content as a string with HTML formatting
  };

  // Start from the live announcement so admins edit it instead of retyping it.
  useEffect(() => {
    axios
      .get(`${SERVERURL}/api/v1/getAnnouncement`)
      .then((response) => {
        if (response.data.banner) setBanner(response.data.banner);
      })
      .catch((error) => console.error("Error fetching announcement:", error));
  }, []);

  const [errors, setErrors] = useState({});
  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  const validateForm = () => {
    const errors = {};
    const strippedBanner = stripHtml(banner); // Strip HTML tags for validation

    if (!strippedBanner.trim()) {
      errors.banner = "Banner detail is required";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const uploadOnServer = async () => {
    if (!validateForm()) {
      return;
    }
    try {

      const form = new FormData();
      form.append("banner", banner);
      const token = localStorage.getItem('token'); 
      const headers = {
        'Authorization': `Bearer ${token}`, // Corrected header format
      };
      const response = await axios.post(`${SERVERURL}/api/v1/AddAnnouncement`, form, {
        headers: headers, // Include the headers object in the request configuration
      });

          if(response.data.success === true)
          {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Banner Announcement Added Successfully.",
            });
            
          }
          else {
            Swal.fire({
              icon: "error",
              title: response.data.message,
             text: "",
            });
          }
      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        text: "Banner Announcement Not Added.",
      });
    }
  };
  return (
    <AdminPage title={COPY.title} subtitle={COPY.subtitle}>
      <div className="admin-card" style={{ maxWidth: "720px" }}>
        <div className="admin-field">
          <label className="admin-label" htmlFor="banner">
            {COPY.announcement}
          </label>
          <ReactQuill value={banner} onChange={handleBannerChange} />
          {errors.banner && <p className="admin-error">⚠ {errors.banner}</p>}
        </div>

        <div className="admin-form-actions">
          <button className="admin-btn" type="button" onClick={uploadOnServer}>
            {COPY.upload}
          </button>
        </div>
      </div>
    </AdminPage>
  );
};

export default AddBanner;
